import * as localforage from "localforage";
import type {EBirdChecklistByFamily, EBirdObservationsByLocation, EBirdObservationsBySpecies} from "ebird-mydata-reader";
import {LIFE_JOURNEY_CACHE_KEY} from "../views/discover/constants";
import type {LocationEcoregionData} from "./types";

export const DERIVED_BIRD_DATA_CACHE_KEY = 'derivedBirdDataCache';
export const DERIVED_BIRD_DATA_CACHE_VERSION = 3;
export const LOCATION_ECO_DATA_CACHE_KEY = 'locationEcoDataCache';
export const LOCATION_ECO_DATA_CACHE_VERSION = 2;
export const DASHBOARD_SUMMARY_CACHE_KEY = 'dashboardSummaryCache';
export const DASHBOARD_SUMMARY_CACHE_VERSION = 1;

export type CachedDerivedBirdData = {
    version: number,
    observationsBySpecies: EBirdObservationsBySpecies[],
    observationsByLocation: EBirdObservationsByLocation[],
    checklist: EBirdChecklistByFamily[]
}

export type CachedLocationEcoData = {
    version: number,
    ecoDataByLocationId: Record<string, LocationEcoregionData>
}

export type DashboardYearStats = {
    species: number,
    locations: number,
    days: number,
    lifers: number
}

export type DashboardRecentActivity = {
    id: string,
    title: string,
    meta: string,
    dateLabel: string,
    taxonomicOrder?: number,
    speciesDetailPath?: string,
    timestamp: number
}

export type DashboardSummary = {
    version: number,
    speciesDetailPathByTaxonomicOrder: Record<string, string>,
    yearStatsByYear: Record<string, DashboardYearStats>,
    recentActivity: DashboardRecentActivity[],
    numYears: number
}

export const clearDerivedBirdDataCaches = async () => {
    await Promise.all([
        localforage.removeItem(DERIVED_BIRD_DATA_CACHE_KEY),
        localforage.removeItem(LOCATION_ECO_DATA_CACHE_KEY),
        localforage.removeItem(DASHBOARD_SUMMARY_CACHE_KEY),
        localforage.removeItem(LIFE_JOURNEY_CACHE_KEY)
    ]);
}
